import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/learnCard/base"

const learnCard = {
  learnCardListPage(pageSize, limit, type, keyWord, cardNumber, classId, schoolId, cardType) {
    return axios.get(pre + `/learnCardListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          type: type,
          keyWord: keyWord,
          cardNumber: cardNumber,
          classId: classId,
          schoolId: schoolId,
          cardType: cardType,
        }
    });
  },

  learnCardInfo(id) {
    return axios.get(pre + `/learnCardInfo`, {
      params:
        {
          id: id
        }
    });
  },

  learnCardUpdate(params) {
    return axios.post(pre + `/learnCardUpdate`, qs.stringify(params));
  },

  learnCardBatchUpdate(id, cardType, classId, schoolId, gradeIds, overDate) {
    return axios.post(pre + `/learnCardBatchUpdate`, qs.stringify({
      id: id,
      cardType: cardType,
      classId: classId,
      schoolId: schoolId,
      gradeIds: gradeIds,
      overDate: overDate
    }));
  },

  learnCardBatchSave(batchNumber, cardType, number, title, price, classId, schoolId, gradeIds, overDate) {
    return axios.post(pre + `/learnCardBatchSave`, qs.stringify({
      batchNumber: batchNumber,
      cardType: cardType,
      number: number,
      title: title,
      price: price,
      classId: classId,
      schoolId: schoolId,
      gradeIds: gradeIds,
      overDate: overDate
    }));
  },
  learnCardStop(id) {
    return axios.post(pre + `/learnCardStop`, qs.stringify({
      id: id,
    }));
  },

  learnCardStart(id, overDate) {
    return axios.post(pre + `/learnCardStart`, qs.stringify({
      id: id,
      overDate: overDate,
    }));
  },
}
export default learnCard;



// WEBPACK FOOTER //
// ./src/api/learnCard/learnCard.js